import { defineStore } from 'pinia';
import FunnelReportsAPI from 'dashboard/api/funnelReports';

export const useFunnelReportsStore = defineStore('funnelReports', {
  state: () => ({
    report: null,
    loading: false,
    drill: {
      stage: null,
      items: [],
      total: 0,
      page: 1,
      per: 25,
      loading: false,
    },
  }),
  actions: {
    async fetch(params = {}) {
      this.loading = true;
      try {
        const { data } = await FunnelReportsAPI.show(params);
        this.report = data;
        return data;
      } finally {
        this.loading = false;
      }
    },
    async exportCsv(params = {}) {
      const response = await FunnelReportsAPI.export(params);
      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `funnel-${new Date().toISOString().slice(0, 10)}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    },
    async fetchDrill(params = {}) {
      this.drill.loading = true;
      try {
        const { data } = await FunnelReportsAPI.drillPreAttendance(params);
        this.drill = { ...data, loading: false };
        return data;
      } catch (e) {
        this.drill.loading = false;
        throw e;
      }
    },
    resetDrill() {
      this.drill = {
        stage: null,
        items: [],
        total: 0,
        page: 1,
        per: 25,
        loading: false,
      };
    },
  },
});
